export interface Produto {
  id: string;
  nome: string;
  categoria: string;
  custo: number;
  custoExtra: number;
  precoVenda: number;
  margem: number;
  estoque: number;
  status: 'ativo' | 'inativo';
  criadoEm: string;
}

export interface Cliente {
  id: string;
  nome: string;
  telefone: string;
}

export interface Venda {
  id: string;
  produtoId: string;
  produtoNome: string;
  quantidade: number;
  valorTotal: number;
  formaPagamento: 'dinheiro' | 'pix' | 'cartao';
  taxaCartao: number;
  valorLiquido: number;
  data: string;
  clienteId?: string;
  clienteNome?: string;
  descontoPercentual?: number;
  valorDesconto?: number;
}

export interface Despesa {
  id: string;
  descricao: string;
  valor: number;
  categoria: string;
  data: string;
}

export interface Aporte {
  id: string;
  valor: number;
  data: string;
  observacao: string;
}

export interface Retirada {
  id: string;
  valor: number;
  data: string;
}

export interface RetiradaProduto {
  id: string;
  produtoId: string;
  produtoNome: string;
  quantidade: number;
  custoUnitario: number;
  custoTotal: number;
  motivo: string;
  data: string;
}

export const mockProdutos: Produto[] = [
  { id: '1', nome: 'Camiseta Básica Preta', categoria: 'Camisetas', custo: 25, custoExtra: 3, precoVenda: 79.9, margem: 65.2, estoque: 42, status: 'ativo', criadoEm: '2024-01-10' },
  { id: '2', nome: 'Calça Jogger Cinza', categoria: 'Calças', custo: 55, custoExtra: 5, precoVenda: 149.9, margem: 60.0, estoque: 18, status: 'ativo', criadoEm: '2024-01-15' },
  { id: '3', nome: 'Moletom Oversized', categoria: 'Moletons', custo: 70, custoExtra: 8, precoVenda: 199.9, margem: 61.0, estoque: 25, status: 'ativo', criadoEm: '2024-02-01' },
  { id: '4', nome: 'Shorts Tactel', categoria: 'Shorts', custo: 30, custoExtra: 2, precoVenda: 89.9, margem: 64.4, estoque: 35, status: 'ativo', criadoEm: '2024-02-10' },
  { id: '5', nome: 'Regata Dry Fit', categoria: 'Regatas', custo: 18, custoExtra: 2, precoVenda: 59.9, margem: 66.8, estoque: 0, status: 'inativo', criadoEm: '2024-02-20' },
  { id: '6', nome: 'Jaqueta Corta Vento', categoria: 'Jaquetas', custo: 95, custoExtra: 10, precoVenda: 279.9, margem: 62.9, estoque: 12, status: 'ativo', criadoEm: '2024-03-01' },
];

export const mockClientes: Cliente[] = [
  { id: '1', nome: 'Maria Silva', telefone: '(11) 98765-4321' },
  { id: '2', nome: 'João Pereira', telefone: '(11) 91234-5678' },
  { id: '3', nome: 'Ana Costa', telefone: '(11) 99876-5432' },
];

export const mockVendas: Venda[] = [
  { id: '1', produtoId: '1', produtoNome: 'Camiseta Básica Preta', quantidade: 5, valorTotal: 399.5, formaPagamento: 'pix', taxaCartao: 0, valorLiquido: 359.55, data: '2024-03-05', clienteId: '1', clienteNome: 'Maria Silva', descontoPercentual: 10, valorDesconto: 39.95 },
  { id: '2', produtoId: '2', produtoNome: 'Calça Jogger Cinza', quantidade: 3, valorTotal: 449.7, formaPagamento: 'cartao', taxaCartao: 2.99, valorLiquido: 436.24, data: '2024-03-08', clienteId: '2', clienteNome: 'João Pereira' },
  { id: '3', produtoId: '3', produtoNome: 'Moletom Oversized', quantidade: 4, valorTotal: 799.6, formaPagamento: 'dinheiro', taxaCartao: 0, valorLiquido: 799.6, data: '2024-03-12', clienteId: '3', clienteNome: 'Ana Costa' },
  { id: '4', produtoId: '4', produtoNome: 'Shorts Tactel', quantidade: 6, valorTotal: 539.4, formaPagamento: 'pix', taxaCartao: 0, valorLiquido: 539.4, data: '2024-03-15', clienteId: '1', clienteNome: 'Maria Silva' },
  { id: '5', produtoId: '6', produtoNome: 'Jaqueta Corta Vento', quantidade: 2, valorTotal: 559.8, formaPagamento: 'cartao', taxaCartao: 3.49, valorLiquido: 540.27, data: '2024-03-18', clienteId: '2', clienteNome: 'João Pereira' },
  { id: '6', produtoId: '1', produtoNome: 'Camiseta Básica Preta', quantidade: 8, valorTotal: 639.2, formaPagamento: 'dinheiro', taxaCartao: 0, valorLiquido: 639.2, data: '2024-03-22', clienteId: '3', clienteNome: 'Ana Costa' },
  { id: '7', produtoId: '3', produtoNome: 'Moletom Oversized', quantidade: 2, valorTotal: 399.8, formaPagamento: 'pix', taxaCartao: 0, valorLiquido: 379.81, data: '2024-03-25', clienteId: '1', clienteNome: 'Maria Silva', descontoPercentual: 5, valorDesconto: 19.99 },
  { id: '8', produtoId: '2', produtoNome: 'Calça Jogger Cinza', quantidade: 4, valorTotal: 599.6, formaPagamento: 'cartao', taxaCartao: 2.99, valorLiquido: 494.42, data: '2024-03-28', clienteId: '2', clienteNome: 'João Pereira', descontoPercentual: 15, valorDesconto: 89.94 },
];

export const mockDespesas: Despesa[] = [
  { id: '1', descricao: 'Aluguel da loja', valor: 1200, categoria: 'Aluguel', data: '2024-03-01' },
  { id: '2', descricao: 'Energia elétrica', valor: 180, categoria: 'Utilidades', data: '2024-03-05' },
  { id: '3', descricao: 'Embalagens e sacolas', valor: 95, categoria: 'Materiais', data: '2024-03-08' },
  { id: '4', descricao: 'Instagram Ads', valor: 300, categoria: 'Marketing', data: '2024-03-10' },
  { id: '5', descricao: 'Frete fornecedor', valor: 150, categoria: 'Logística', data: '2024-03-12' },
  { id: '6', descricao: 'Internet', valor: 89.9, categoria: 'Utilidades', data: '2024-03-15' },
];

export const mockAportes: Aporte[] = [
  { id: '1', valor: 3000, data: '2024-01-01', observacao: 'Capital inicial para estoque' },
  { id: '2', valor: 1500, data: '2024-02-01', observacao: 'Reforço para nova coleção' },
  { id: '3', valor: 800, data: '2024-03-01', observacao: 'Cobertura de despesas fixas' },
];

export const mockRetiradas: Retirada[] = [
  { id: '1', valor: 500, data: '2024-02-28' },
  { id: '2', valor: 700, data: '2024-03-20' },
];

export const mockRetiradaProdutos: RetiradaProduto[] = [
  { id: '1', produtoId: '1', produtoNome: 'Camiseta Básica Preta', quantidade: 2, custoUnitario: 28, custoTotal: 56, motivo: 'Uso pessoal', data: '2024-03-10' },
  { id: '2', produtoId: '3', produtoNome: 'Moletom Oversized', quantidade: 1, custoUnitario: 78, custoTotal: 78, motivo: 'Presente', data: '2024-03-18' },
];